import { DocumentRecordType } from "@/types";
import { Box, Typography } from "@mui/material";

interface DocumentEmptyProps {
  recordType?: DocumentRecordType;
}

enum DocumentRecordTitle {
  CLAIM = "claim",
  POLICY = "policy",
  CLAIMANT = "claimant",
  CLIENT = "client",
  DOCUMENT = "document",
  REIMBURSEMENT = "reimbursement",
}

const DocumentEmptyView = ({ recordType }: DocumentEmptyProps) => {
  // Get resource type for empty state message
  const getResourceType = () => {
    switch (recordType) {
      case DocumentRecordType.STOPLOSS_CLAIMS:
        return DocumentRecordTitle.CLAIM;
      case DocumentRecordType.POLICIES:
        return DocumentRecordTitle.POLICY;
      case DocumentRecordType.CLAIMANTS:
        return DocumentRecordTitle.CLAIMANT;
      case DocumentRecordType.CLIENTS:
        return DocumentRecordTitle.CLIENT;
      case DocumentRecordType.REIMBURSEMENTS:
        return DocumentRecordTitle.REIMBURSEMENT;
      default:
        return DocumentRecordTitle.DOCUMENT;
    }
  };

  const resourceType = getResourceType();

  return (
    <Box textAlign="center" py={6} color="text.secondary">
      <Typography variant="h6" gutterBottom>
        {recordType ? `No ${resourceType} documents` : "No documents"}
      </Typography>
      <Typography variant="body2">
        {recordType
          ? `Upload new ${resourceType} documents to see them here.`
          : "Upload new documents to see them here."}
      </Typography>
    </Box>
  );
};

export default DocumentEmptyView;
